export default __webpack_public_path__ + "static/media/3_1.5bd0ff4d.jpeg";